export const isLastOfArray = (array, index) => {
  return array.length - 1 === index;
};

export const isLastOfArrayId = (array, selectedId) => {
  return array[array.length - 1]?.id === selectedId
};